import { useLayoutEffect, useState } from "react";
import { useAppContext } from "../../../contexts/app";
import { Field, Label } from "../../../components/forms";
import { UseGoogleSheet } from "../../../hooks/UseGoogleSheets";
import { FieldsetWrapperFS } from "../unit/page";


const CustomerItem = ({ uuid, businessName, customerName }) => {
	return <>
		<div className="tw-border tw-border-pink-200 tw-my-10 tw-p-5">
			<h1><b>{ businessName }</b> - { customerName }</h1>

			<a href={`/fs/customer/${uuid}`} className="tw-text-white tw-text-lg tw-font-bold tw-underline">
				<span className="tw-pointer-events-none">
					Edit
				</span>
			</a>
		</div>
	</>
}

export default function Customers() {

	const appContext = useAppContext();
	const [customerRows, setCustomerRows] = useState([]);
	const [unitSearch, setUnitSearch] = useState("");

	//Customers google sheet
	const { loadSheet: loadCustomerSheet } = UseGoogleSheet({ spreadsheetId: process.env.REACT_APP_FS_CUSTOMER });

	useLayoutEffect(() => {
		loadCustomerSheet(true).then((sheets) => {
			setCustomerRows(sheets);
		});
	}, []);

	// Filter rows based on the search input
	const filteredCustomerRows = customerRows.filter((row) => {
		const customerName = row.get("Customer Name");
		return customerName && customerName.toLowerCase().includes(unitSearch.toLowerCase());
	});

	return <>
		<div className="tw-w-full">
			{ appContext.rows &&
				<div>
				 {/* Search Input Field */}
				 <FieldsetWrapperFS title="Search Customers" className="tw-mb-5">
					<Field
					type="text"
					value={unitSearch}
					onChange={(e) => setUnitSearch(e.target.value)} // Update search state
					/>
					<Label>Search</Label>
				</FieldsetWrapperFS>
					<br />
					{filteredCustomerRows.map((row) => {
						const customerName = row.get("Customer Name");
						const uuid = row.get("UUID");
						return (
						uuid && (
							<CustomerItem
								key={uuid}
								uuid={uuid}
								customerName={customerName}
								businessName={row.get("Business Name")}
							/>
						)
						);
					})}

				</div>
			}
		</div>
	</>
}
